export default function replaceUrlParameters(maskedUrl, replacements = {}) {
  // Handle invalid inputs
  if (!maskedUrl || typeof maskedUrl !== "string") {
    throw new Error("Invalid URL: must be a non-empty string");
  }

  if (!replacements || typeof replacements !== "object") {
    return maskedUrl; // Return original if no replacements provided
  }

  try {
    // Parse the URL
    const url = new URL(maskedUrl);

    // Get all current parameters
    const params = new URLSearchParams(url.search);

    // Replace parameters that exist in the replacements object
    for (const [paramName, newValue] of Object.entries(replacements)) {
      if (params.has(paramName)) {
        // Replace the parameter value
        params.set(paramName, newValue);
      }
      // Note: If parameter doesn't exist in URL, we don't add it
    }

    // Rebuild the URL with updated parameters
    url.search = params.toString();

    return url.toString();
  } catch (error) {
    throw new Error(`Failed to parse URL: ${error.message}`);
  }
}
